export const floatSelector = state => {
    return state['float'];
  };
  
  export default floatSelector;
  